<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_info">
            <tt-input ttLabel="furniturefabrics_id" [ttModel]="menu.furniturefabrics_id" ttReadonly></tt-input>
            <tt-input ttLabel="furniturefabrics_name" [ttModel]="menu.furniturefabrics_name" ttReadonly></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_functions">
            <tt-button-goto [ttText]="'furniturefabricsmenu_edit'" [ttGoto]="'furniturefabrics'" [ttGotoParms]="{ furniturefabrics_id: menu.furniturefabrics_id }"></tt-button-goto>
            <tt-button-goto [ttText]="'furniturefabricsmenu_furniturefabricscolors'" [ttBadge]="menu.nbr_of_furniturefabricscolor" [ttGoto]="'furniturefabricscolors'" [ttGotoParms]="{ furniturefabrics_id: menu.furniturefabrics_id }"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-input class="col-xs-12 sp-0" tt-label="furniturefabrics_id" tt-model="vm.model.menu.furniturefabrics_id" tt-change="vm.model.menu.furniturefabrics_id = $value" tt-readonly="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="furniturefabrics_name" tt-model="vm.model.menu.furniturefabrics_name" tt-change="vm.model.menu.furniturefabrics_name = $value" tt-readonly="true"></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-button-goto class="col-xs-12 sp-0" tt-text="furniturefabricsmenu_edit" tt-goto="furniturefabrics" tt-goto-parms="{ furniturefabrics_id: vm.model.menu.furniturefabrics_id }" tt-text-align="left"></tt-button-goto>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="furniturefabricsmenu_furniturefabricscolors" tt-badge="{{vm.model.menu.nbr_of_furniturefabricscolor}}" tt-goto="furniturefabricscolors" tt-goto-parms="{ furniturefabrics_id: vm.model.menu.furniturefabrics_id }" tt-text-align="left"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>-->
